import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { useTheme } from "styled-components";
import { BoxSpan } from "../../../Styled/Box";
import Button from "../../../Styled/Button";
import { TextSpan } from "../../../Styled/Text";
import { GLYPHS, StyledIcon } from "../../../Styled/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BackButton = _ref => {
  let {
    children,
    onClick
  } = _ref;
  const theme = useTheme();
  return /*#__PURE__*/_jsx(_StyledButton, {
    transparentBg: true,
    onClick: onClick,
    $_css: theme.textLight,
    $_css2: theme.textLight,
    children: /*#__PURE__*/_jsxs(BoxSpan, {
      centered: true,
      children: [/*#__PURE__*/_jsx(_StyledStyledIcon, {
        light: true,
        styledWidth: "16px",
        glyph: GLYPHS.arrowDown
      }), /*#__PURE__*/_jsx(TextSpan, {
        noFontSize: true,
        children: children
      })]
    })
  });
};
export default BackButton;
var _StyledButton = _styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        color: ", ";\n        border-color: ", ";\n        margin: 2em 0 1em 0;\n      "])), p => p.$_css, p => p.$_css2);
var _StyledStyledIcon = _styled2(StyledIcon).withConfig({
  displayName: "BackButton___StyledStyledIcon",
  componentId: "sc-7kx2ba-0"
})(["transform:rotate(90deg);"]);